<template>
  <div class="main">
    <Header/>
    <div class="form">
      <el-form ref="form" :model="form" label-width="80px">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        <el-row :gutter="10">
          <el-col :span="16">
            <el-input v-model="form.code" placeholder="请输入短信验证码"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button :loading="this.$data.sendSmsCodeLoading" :disabled="countDown !== 0" @click="onSendCode"
                       style="width: 100%">
              {{ countDown === 0 ? '发送验证码' : countDown }}
            </el-button>
          </el-col>
        </el-row>
        <el-button :loading="loginLoading" type="primary" @click="onLogin" style="width: 100%">立即登陆</el-button>
      </el-form>
      <div class="desc">
        IOS稳定版需要登录后才能进行下载，请先登录。<br/>没有注册账号的在登录时会自动创建账号无法安装请点击右下角人工客服
      </div>
    </div>
    <ContactUs/>
  </div>
</template>

<script>
import Header from '@/components/Header';
import ContactUs from "../components/contact-us";

export default {
  name: "login-phone",
  components: {
    Header,
    ContactUs,
  },
  data() {
    return {
      // 表单数据
      form: {
        phone: '',
        code: ''
      },
      // 当前倒计时
      countDown: 0,
      // 最大倒计时
      maxCountDown: 59,
      // 发送短信验证码是否加载中
      sendSmsCodeLoading: false,
      // 登陆按钮是否加载中
      loginLoading: false,
    }
  },
  created() {

  },
  methods: {
    // 立即登陆按钮点击事件
    onLogin() {
      this.$data.loginLoading = true;
      this.$axios.post(`/api/user/user/user/login/sms-code`, this.$data.form).then((res) => {
        if (res.code === 200) {
          sessionStorage.setItem("Token", res.data.token);
          this.jump();
        }
      }).finally(() => this.$data.loginLoading = false);
    },
    // 跳转事件
    jump(){
      // 获得目标地址
      location.href = this.$route.query.url ?? "/";
    },
    // 发送验证码按钮点击事件
    onSendCode() {
      if (this.$data.countDown > 0) return;
      this.sendCode(this.$data.form.phone);
    },
    // 发送短信验证码
    sendCode(phone) {
      this.$data.sendSmsCodeLoading = true;
      this.$axios.post(`/api/message/sms/send-code`, {target: phone}).then((res) => {
        if (res.code === 200) {
          this.$message({message: res.msg, type: 'success'});
          this.startSmsCodeCountDown();
        }
      }).finally(() => this.$data.sendSmsCodeLoading = false);
    },
    // 开始短信验证码短信倒计时
    startSmsCodeCountDown() {
      this.$data.countDown = this.$data.maxCountDown;
      let time = setInterval(() => {
        this.$data.countDown = this.$data.countDown - 1;
        if (this.$data.countDown === 0) {
          clearInterval(time);
        }
      }, 1000);
    },
  }
}
</script>

<style scoped>
.main {
  background: #f5f5f5;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
}

.form {
  margin-top: 20px;
  padding: 20px;
  background: #FFF;
}

.form * {
  margin-bottom: 10px;
}

.desc {
  color: #ccc;
  font-size: 14px;
}
</style>
